import { FormData, FormStatus } from '@/types/form';

export const MAX_LOAN = 250000;
export const MAX_INCOME = 1000000;

export const allowedEmailDomains = [
  'com',
  'net',
  'edu',
  'org',
  'me',
  'us',
  'co',
  'gov',
];

export const formDefaultValues: FormData = {
  first_name: '',
  last_name: '',
  borrow_sum: '',
  loan_reason: null,
  annual_income: '',
  payment_frequency: null,
  unsecured_debt_value: null,
  address: '',
  address_variant: 'google',
  city: '',
  apt: '',
  state: null,
  zip: '',
  house_ownership: null,
  email: '',
  phone: '',
  creditRating: null,
  educational_level: null,
  employment_status: null,
  date_of_birth: '',
  ssn: '',
};

export const initialFormStatus: FormStatus = {
  userId: null,
  loading: true,
  submissionLoading: false,
  redirectValue: '',
  stepLoading: false,
  loadingCheckmark: null,
  verificationError: false,
  submissionError: null,
};
